module.exports = "/img/rapbeat_bg_mobile.jpg?aea0e55f30d4e310ec15d677ca8e3c29";